import { render, staticRenderFns } from "./Wp_open_by_browser.vue?vue&type=template&id=8822ff78&scoped=true&"
import script from "./Wp_open_by_browser.vue?vue&type=script&lang=js&"
export * from "./Wp_open_by_browser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8822ff78",
  null
  
)

export default component.exports